import { IBlogResponse } from "@/types/blog.type";
import { BASE_URL, STRAPI_HEADERS } from "./strapi-config";
import { TFaqDetailResponse, TFaqResponse, TFeatureFaqResponse, THotTopicsResponse } from "@/types/faq.type";

export const getFAQs = (): Promise<TFaqResponse> => {
  return fetch(`${BASE_URL}/faqs`, STRAPI_HEADERS)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data: TFaqResponse) => {
      return data;
    });
};

export const getFaqDetail = (
  locale: string,
  id: number
): Promise<TFaqDetailResponse> => {
  return fetch(
    `${BASE_URL}/faqs/${encodeURIComponent(id)}?locale=${encodeURIComponent(locale)}&populate[0]=seo&populate[1]=faq_tags&populate[2]=faq_categories`,
    STRAPI_HEADERS
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data: TFaqDetailResponse) => {
      return data;
    });
};

export const getHotTopics = (locale: string): Promise<THotTopicsResponse> => {
  return fetch(`${BASE_URL}/hot-topic?populate=faqs&populate[1]=faqs.seo`, STRAPI_HEADERS)
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data: THotTopicsResponse) => {
      return data;
    });
};

export const getFeaturedFAQs = (locale: string): Promise<TFeatureFaqResponse> => {
  return fetch(
    `${BASE_URL}/feature-faq?populate=faqs&populate[1]=faqs.seo`,
    STRAPI_HEADERS
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data: TFeatureFaqResponse) => {
      return data;
    });
};

export const getFaqBySlug = (
  slug: string
): Promise<TFaqResponse> => {
  return fetch(
    `${BASE_URL}/faqs?filters[slug][$eq]=${encodeURIComponent(slug)}`,
    STRAPI_HEADERS
  )
    .then((response) => {
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      return response.json();
    })
    .then((data: TFaqResponse) => {
      return data;
    });
};
